import type { MapCartographieData } from "../../api/etablissement";

/** Données de démo (Bénin) — page Maps publique sans authentification. */
export const MOCK_MAP_CARTOGRAPHIE_DATA: MapCartographieData = {
  center: { latitude: 6.37, longitude: 2.42 },
  radius: 15,
  etablissements: [
    {
      id: "mock-chu-cotonou",
      nom: "CHU Hubert Koutoukou Maga",
      type: "hopital",
      coordonnees: { latitude: 6.3725, longitude: 2.3544 },
      litsCount: 12,
      sangCount: 45,
      produitsCount: 48,
      sangParGroupe: {
        "A+": { disponible: 4, reservee: 0, utilisee: 1, expiree: 0, rejetee: 0 },
        "O+": { disponible: 6, reservee: 1, utilisee: 2, expiree: 0, rejetee: 0 },
        "B+": { disponible: 2, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
      },
      tauxOccupationLits: 65,
      commune: "Cotonou",
    },
    {
      id: "mock-hopital-menontin",
      nom: "Hôpital de zone de Ménontin",
      type: "hopital",
      coordonnees: { latitude: 6.365, longitude: 2.42 },
      litsCount: 5,
      sangCount: 0,
      produitsCount: 0,
      tauxOccupationLits: 80,
      commune: "Cotonou",
    },
    {
      id: "mock-calavi",
      nom: "Centre hospitalier Abomey-Calavi",
      type: "centre_sante",
      coordonnees: { latitude: 6.4485, longitude: 2.3556 },
      litsCount: 8,
      sangCount: 4,
      produitsCount: 120,
      sangParGroupe: {
        "O-": { disponible: 3, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
        "AB+": { disponible: 1, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
      },
      tauxOccupationLits: 50,
      commune: "Abomey-Calavi",
    },
    {
      id: "mock-pharmacie-ganhi",
      nom: "Pharmacie du Ganhi",
      type: "pharmacie",
      coordonnees: { latitude: 6.358, longitude: 2.438 },
      litsCount: 0,
      sangCount: 0,
      produitsCount: 340,
      commune: "Cotonou",
    },
    {
      id: "mock-porto-novo",
      nom: "Centre national hospitalier et universitaire",
      type: "hopital",
      coordonnees: { latitude: 6.4969, longitude: 2.6283 },
      litsCount: 20,
      sangCount: 11,
      produitsCount: 15,
      sangParGroupe: {
        "A+": { disponible: 2, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
        "A-": { disponible: 1, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
        "B+": { disponible: 3, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
        "O+": { disponible: 5, reservee: 0, utilisee: 0, expiree: 0, rejetee: 0 },
      },
      tauxOccupationLits: 40,
      commune: "Porto-Novo",
    },
  ],
  statistics: {
    totalEtablissements: 5,
    totalLits: 45,
    totalSang: 60,
    totalProduits: 523,
  },
};
